// ─── Brand Assets ────────────────────────────────────────

export const MASCOT_IMAGE_URL =
    "https://pub-95de99c56e154e8da00079375041f7f5.r2.dev/iloramascott.png";

export const LOGO_HORIZONTAL_URL =
    "https://pub-95de99c56e154e8da00079375041f7f5.r2.dev/ilorisHorizontalLogo.png?v=2";

export const LOGO_IMAGE_URL =
    "https://pub-95de99c56e154e8da00079375041f7f5.r2.dev/ilorisLogo.png";

// ─── Validation Limits ───────────────────────────────────

export const MAX_TITLE_LENGTH = 200;
export const MAX_VOLUME_TITLE_LENGTH = 120;
export const MAX_SYNOPSIS_LENGTH = 2000;
export const MAX_SLUG_ATTEMPTS = 100;
export const MAX_IMPORT_CHAPTERS = 3000;
export const MAX_TAGS_PER_STORY = 10;
export const MAX_TAG_LENGTH = 30;
/** Max serialized JSON size of a chapter's TipTap content (~5MB). */
export const MAX_CHAPTER_CONTENT_SIZE = 5_000_000;
/** Max serialized JSON size of a chapter's author's note. The editor caps the
 *  note at ~1,000 VISIBLE chars; this JSON-byte ceiling sits well above the
 *  worst-case markup inflation of that (links store full hrefs + mark overhead)
 *  so a legitimate note is never spuriously rejected, while still bounding a
 *  hand-crafted direct API payload. Notes are asides, not content. */
export const MAX_AUTHOR_NOTE_SIZE = 50_000;

// ─── Articles ────────────────────────────────────────────

export const MAX_ARTICLE_BYLINE_LENGTH = 100;
export const MAX_ARTICLE_EXCERPT_LENGTH = 500;
/** Max raw markdown size for an article (~500KB). */
export const MAX_ARTICLE_MARKDOWN_SIZE = 500_000;
